import styles from "./SupportSearch.module.css";

const SupportSearch = ({ searchText, setSearchText }) => {
    return (
        <div className={styles.supportSearch} data-testid="support-search">
            <input
                className={styles.supportSearchInput}
                placeholder="Search for what you're after"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
            />
        </div>
    );
};

export default SupportSearch;
